<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header d-flex align-items-center">
				<span class="mr-auto">
					<i class="fa fa-road"></i> Rutas Disponibles
				</span>
				<span class="ml-auto">
					<button class="btn btn-primary" (click)="add()">
						<i class="fa fa-plus-square"></i>
						Agregar una ruta
					</button>
				</span>
			</div>
			<div class="card-body">
				<app-datatable [options]="dtConfig"></app-datatable>
			</div>
		</div>
	</div>
</div>